import { Brand } from '@awaze/design-system.components.awaze-theme-provider'

export interface BrandConfig {
  contenfulEntryIds: {
    footer: string
    header: string
  }
  brand: Brand
}

type BrandConfigs = {
  [key in Brand | 'jamesVillas']: BrandConfig & {
    contenfulEntryIds: {
      footer: string
      header: string
    }
  }
}

const brandConfig: BrandConfigs = {
  'cottages.com': {
    brand: 'cottages.com',
    contenfulEntryIds: {
      footer: 'Hl315LKwqQxWnEZ7Pmob9',
      header: '2Tm06WIefg7Z4m87zl2bb3',
    },
  },
  hoseasons: {
    brand: 'hoseasons',
    contenfulEntryIds: {
      footer: '1IRrRzoUHYlAvlIf7Fth1V',
      header: '7F36zZK10UxSzSK2U5PskW',
    },
  },
  awaze: {
    brand: 'awaze',
    contenfulEntryIds: {
      footer: 'Hl315LKwqQxWnEZ7Pmob9',
      header: '4PohPbbfEZrLi9WtDvfUgj',
    },
  },
  novasol: {
    brand: 'novasol',
    contenfulEntryIds: {
      footer: '4dCMxEiSuRYtMnvGbCwxGG',
      header: '1CdxOcBwRUoDK4XROXKksc',
    },
  },
  dansommer: {
    brand: 'dansommer',
    contenfulEntryIds: {
      footer: 'Hl315LKwqQxWnEZ7Pmob9',
      header: '4PohPbbfEZrLi9WtDvfUgj',
    },
  },
  agnostic: {
    brand: 'awaze',
    contenfulEntryIds: {
      footer: 'Hl315LKwqQxWnEZ7Pmob9',
      header: '4PohPbbfEZrLi9WtDvfUgj',
    },
  },
  novasolOwner: {
    brand: 'novasolOwner',
    contenfulEntryIds: {
      footer: 'Hl315LKwqQxWnEZ7Pmob9',
      header: '4PohPbbfEZrLi9WtDvfUgj',
    },
  },
  fincallorca: {
    brand: 'awaze',
    contenfulEntryIds: {
      footer: 'Hl315LKwqQxWnEZ7Pmob9',
      header: 'DiYlbWNfEKqj3Rzn23eFy',
    },
  },
  jamesVillas: {
    brand: 'jamesVillas' as Brand,
    contenfulEntryIds: {
      footer: '2JmpYrbPHjfFALYDk2ELlf',
      header: '3NHvGYR5cPoiKCMOo0JogG',
    },
  },
  coreInternal: {
    brand: 'awaze',
    contenfulEntryIds: {
      footer: 'Hl315LKwqQxWnEZ7Pmob9',
      header: '4PohPbbfEZrLi9WtDvfUgj',
    },
  },
}

export const getBrandConfig = (brand: Brand): BrandConfig =>
  brandConfig[brand] || brandConfig['cottages.com']
